import axios from "axios";
import ApiConfig from "../config/ApiConfig";
import {
  setLoading,
  setBrowseCategory,
  setBrowseCategoryError,
  setSubBrowseCategory,
  setVideoBrowseCategory,
  setVideoBrowseCategoryError,
  setSubBrowseCategoryError,
  setStarsCollectionBrowseCategory,
  setStarsCollectionBrowseCategoryError,
} from "../redux/homepage";
import { toast } from "react-toastify";
import { STATUS_200, STATUS_300 } from "../data/constants";
import { errorMessage } from "../lib/helper";

export const GetMainBrowseCategories = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.get(`${ApiConfig.browseMainCategory}`);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
        let dataCopy = [...resp.data.data];
        dataCopy = dataCopy.map((item) => ({
          ...item,
          sort_id: item.sort_id === null ? -1 : Number(item.sort_id),
        }));
        dataCopy.sort((a, b) => a.sort_id - b.sort_id);
        dispatch(setBrowseCategory(dataCopy));
        dispatch(setLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setBrowseCategoryError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setLoading(false));
    }
  };
};
export const GetSubBrowseCategories = (id) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.get(`${ApiConfig.browseSubCategory}/?id=${id}`);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
        dispatch(setSubBrowseCategory(resp.data.data));
        dispatch(setLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setSubBrowseCategoryError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setLoading(false));
    }
  };
};

export const GetMainVideosCategories = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.get(`${ApiConfig.videosBrowseCategory}`);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
        dispatch(setVideoBrowseCategory(resp.data.data));
        dispatch(setLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setVideoBrowseCategoryError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setLoading(false));
    }
  };
};

export const GetStarsCollectionCategories = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.get(
        `${ApiConfig.starsCollectionBrowseCategory}`
      );
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
        dispatch(setStarsCollectionBrowseCategory(resp.data.data));
        dispatch(setLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setStarsCollectionBrowseCategoryError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setLoading(false));
    }
  };
};
